import { useEffect, useState } from "react";
import { Menu as MenuIcon } from "react-feather";
import {
  Menu,
  ProSidebar,
  SidebarContent,
  SidebarHeader,
  SubMenu,
} from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css"; // Import the styles
import { useSelector } from "react-redux";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import "../../App.css";
import sidebarData from "./sidebarData"; // Import your sidebar data
import SideBarItem from "./SideBarItem";
import { initSidebarFavorites } from "./sidebarData.init";

const Sidebar = ({
  selectedCategory,
  onCollapseToggle,
  onSidebarItemClick,
  isSidebarCollapsed,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(null);
  const [isSubActive, setIsSubActive] = useState("");
  const permissions = useSelector((state) => state.user.permissions);

  useEffect(() => {
    (async() => {
      await initSidebarFavorites();
    })();
  }, []);

  const handleToggleCollapse = () => {
    onCollapseToggle();
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleSidebarItemClick = (label, description, parentLabel = "") => {
    setIsActive(label === isActive ? null : label);
    setIsSubActive(parentLabel);
    onSidebarItemClick(label, description);
  };

  const renderSubMenu = (items, parentLabel) => {
    return items.map((subItem, subIndex) => {
      if (subItem.items && subItem.items.length > 0) {
        const isSomeAuthorized = subItem.items.reduce((acc, cur) => {
          const auth = permissions[cur.module]?.[cur.form]?.FORM;
          if (auth?.VIEW === true) {
            acc = true;
          }
          return acc;
        }, false);
        const subItemIsActive = isActive === subItem.label;
        return (
          <SubMenu
            key={subIndex}
            title={subItem.label}
            icon={subItem.icon}
            className={`sidebar-sub-menu ${
              subItemIsActive ? "activemenu" : ""
            }`}
            style={!isSomeAuthorized ? { display: "none" } : {}}
          >
            {renderSubMenu(subItem.items)}
          </SubMenu>
        );
      } else {
        const subItemIsActive = isActive === subItem.label;
        return (
          <SideBarItem
            key={subIndex}
            index={subIndex}
            isActive={subItemIsActive}
            form={subItem.form}
            module={subItem.module}
            item={subItem}
            isInSubMenu={true}
          >
            <Link
              to={subItem.linkName}
              onClick={() =>
                handleSidebarItemClick(
                  subItem.label,
                  subItem.description,
                  parentLabel,
                )
              }
            >
              {subItem.label}
            </Link>
          </SideBarItem>
        );
      }
    });
  };

  const renderSidebarItems = () => {
    const categoryData =
      !selectedCategory || selectedCategory === "Unauthorized"
        ? sidebarData["Master"]
        : selectedCategory === "Mis"
          ? sidebarData["MIS"]
          : sidebarData[selectedCategory];

    return categoryData.map((item, index) => {
      const itemIsActive =
        isActive === item.label || isSubActive === item.label;

      if (item.items && item.items.length > 0) {
        const isSomeAuthorized = item.items.reduce((acc, cur) => {
          const auth = permissions[cur.module]?.[cur.form]?.FORM;
          if (auth?.VIEW === true) {
            acc = true;
          }
          return acc;
        }, false);

        return (
          <SubMenu
            key={index}
            title={item.label}
            icon={<item.icon />}
            className={`sidebar-sub-menu ${
              itemIsActive ? "activemenu" : "notactive"
            }`}
            style={!isSomeAuthorized ? { display: "none" } : {}}
          >
            {renderSubMenu(item.items, item.label)}
          </SubMenu>
        );
      } else {
        return (
          <div className="sidebar-div-container">
            <SideBarItem
              key={index}
              form={item.form}
              module={item.module}
              index={index}
              isActive={itemIsActive}
              item={item}
              isInSubMenu={true}
            >
              <Link
                to={item.linkName}
                onClick={() =>
                  handleSidebarItemClick(item.label, item.description)
                }
              >
                {item.label}
              </Link>
            </SideBarItem>
          </div>
        );
      }
    });
  };

  return (
    <ProSidebar
      collapsed={isSidebarCollapsed}
      style={{
        background: "none",
        zIndex: isSidebarCollapsed || isHovered ? 999 : 0, // Set zIndex to 100 when isSidebarCollapsed or on hover
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <SidebarHeader>
        <div className="sidebar-header">
          {isSidebarCollapsed ? (
            <MenuIcon
              className="toggle-icon"
              color="black"
              onClick={handleToggleCollapse}
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            />
          ) : (
            <MenuIcon
              className="toggle-icon"
              onClick={handleToggleCollapse}
              color="black"
            />
          )}
        </div>
      </SidebarHeader>
      <SidebarContent
        className="sidebar-content"
        style={{ overflowY: "auto", height: "70vh" }}
      >
        <Menu>{renderSidebarItems()}</Menu>
      </SidebarContent>
    </ProSidebar>
  );
};

export default Sidebar;
